import { merge } from '../../helper';

import isEmptyArray from '../../general/isEmpty/isEmptyArray';
import isEmptyObject from '../../general/isEmpty/isEmptyObject';

import exExternal from '../../external';
import exLanguage from '../../language';
import * as exButton from '../../components/button';
import * as exTable from '../table';

// ----------------------------------------------------------------------------

function start(element: HTMLElement, config: Record<string, any> = {}): void {
    // Create element (table wrapper)
    const elTableWrapper = exTable.alreadyTableWrapper(element);

    // Get element (table button)
    let elTableButton = elTableWrapper.querySelector('.table-button');
    // If there is no element (table button)
    if (!elTableButton) {
        // Create element (table button)
        const buttons = exTable.button.create(element, config);
        elTableButton = buttons.element as HTMLElement;
    }

    // --------------------------------------------------------------------

    // If there is button collapse
    if (config.buttonCollapse === true || !isEmptyObject(config.buttonCollapse)) {
        const buttonCollapse = collapse(element, config.buttonCollapse);
        elTableButton.appendChild(buttonCollapse.element);
    }

    // If there is button expand
    if (config.buttonExpand === true || !isEmptyObject(config.buttonExpand)) {
        const buttonExpand = expand(element, config.buttonExpand);
        elTableButton.appendChild(buttonExpand.element);
    }

    // --------------------------------------------------------------------

    // If there is data
    if (!isEmptyArray(config.data)) {
        const listButton = exButton.data(config.data);
        elTableButton.appendChildren(listButton);
    }
}

// ----------------------------------------------------------------------------

function collapse(element: HTMLElement, config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig = {};

    // Merge
    merge(defConfig, config);

    // ----------------------------------------------------------------

    // Create element (button)
    const button = exButton.create({
        merge: defConfig,
        attr: {
            id: 'btn-collapse-all',
            title: exLanguage.line('general.collapse_all'),
        },
        icon: 'fa-solid fa-compress',
        event: {
            mousedown: function (): any {
                // @ts-expect-error
                exExternal.jquery(element).treetable('collapseAll');
            },
        },
    });

    // Return
    return button;
}

function expand(element: HTMLElement, config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig = {};

    // Merge
    merge(defConfig, config);

    // ----------------------------------------------------------------

    // Create element (button)
    const button = exButton.create({
        merge: defConfig,
        attr: {
            id: 'btn-expand-all',
            title: exLanguage.line('general.expand_all'),
        },
        icon: 'fa-solid fa-expand',
        event: {
            mousedown: function (): any {
                // @ts-expect-error
                exExternal.jquery(element).treetable('expandAll');
            },
        },
    });

    // Return
    return button;
}

// ---------------------------------------------------------------------------

export { start };
